import { z } from 'zod';
import { ConversationMessage } from '../client';
import { makeEvent } from './EventBase';

export const ConversationMessageCreated = makeEvent(
    'Conversation\\ConversationMessageCreated',
    z.object({
        data: ConversationMessage,
    }),
);

export type ConversationMessageCreated = (typeof ConversationMessageCreated)['schema']['_output'];
